<template>
    <div id="homepage-container">
        <!-- <div id="image-container">
        </div> -->
    </div>
</template>

<script>

</script>

<style>
#homepage-container{
    height: 100vh;
    width: 100vw;
}

/* #image-container{
    height: 100%;
    object-fit: cover;
} */
/* img{
    width: 100%;
    height: 100%;
} */
</style>